<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'price-group-list'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import { FeatureStorage } from "../../_services/storage";
import { PricingTabs , GetIndexByTabName} from "../../_models/tabdata/sales/pricing-tabs";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {};
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Pricing",
        selectedIndex: GetIndexByTabName("Price Groups"),
        tabs: PricingTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "PriceGroupList",
              filter: [["PriceGroupType" , "<>" , "P"]],
              serverPaging: true,
              allowGrouping: false,
            },
            // rowSelect: {
            //   view: this,
            //   page: "sales-order",
            //   mode: "review",
            //   idProperty: "Code",
            // },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Price Groups",
                message: "Get Started, Add a Price Group",
              },
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/price-group/create",
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission("PriceGroup", "create")
                  ? true
                  : false,
              },
            ],
          },
          columns: [
            {
              screenField: "PriceGroup",
              gridDataField: "Description",
              sortOrder: "desc",
              sortIndex: 0,
              fixed: true,
              fixedPosition: "left",
              allowHiding: false,
            },
            {
              screenField: "Date",
              gridDataField: "SellStartDate",
              label: "Sell Start Date",
              filterLabel: "Sell Start Date",
              filterDataField: "SellStartDate",
              filterIndex: 0,
            },
            {
              screenField: "Date",
              gridDataField: "SellEndDate",
              label: "Sell End Date",
              filterLabel: "Sell End Date",
              filterDataField: "SellEndDate",
              filterIndex: 1,
            },
            {
              screenField: "PriceGroupType",
              width: 150,
              minWidth: 150,
              filterIndex: 2,
              dataSourceConfig: {
                data: ["Off Invoice", "Additional Discount", "Sales Discount"],
              },
            },
            {
              screenField: "Promotion",
              gridDataField: "IsPromotion",
              allowEditing: false,
              makeReadOnly: () => {
                return true;
              },
              width: 120,
              minWidth: 120,
            },
            {
              screenField: "Status",
              gridDataField: "Inactive",
              gridLabel: "Status",
              filterIndex: 3,
              filterDefaultValue: ["N"],
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    rowClickCallBack(e) {
      if (e.rowType == "data" && e.column.screenField != "Status") {
        this.onRowClicked(e, {
          view: this,
          page: "price-group",
          mode: "review",
          idProperty: "Code",
        });
      }
    },
  },

  created() {},
};
</script>

<style lang="scss">
</style>
